module.exports = __webpack_public_path__ + "static/media/pt_mb.897ccca1.svg";